module.exports = __webpack_public_path__ + "media/images/terms-a9872ffd2e5ddf7762930449454983ae.png";